const DEFAULT_MASTER_API_PATH = '/api/v1';
const DEFAULT_MASTER_HOST = 'http://localhost:3001';

export function getApiBaseUrl() {
  const envUrl = process.env.REACT_APP_CLIENT_MASTER_API_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  return `${DEFAULT_MASTER_HOST}${DEFAULT_MASTER_API_PATH}`;
}

export function getClientUrl() {
  const envUrl = process.env.REACT_APP_CLIENT_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim();
  }
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    return window.location.hostname;
  }
  return 'localhost';
}

export function getSourcePage() {
  if (typeof window !== 'undefined' && window.location && window.location.pathname) {
    return window.location.pathname;
  }
  return '';
}

export function buildTsrEnquiryUrl() {
  const base = getApiBaseUrl();
  const clientUrl = encodeURIComponent(getClientUrl());
  return `${base}/tsr/enquiry?ClientUrl=${clientUrl}`;
}

export async function submitTsrEnquiry(payload) {
  const response = await fetch(buildTsrEnquiryUrl(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      sourcePage: payload.sourcePage || getSourcePage(),
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Unable to send your request. Please try again.');
  }

  return data;
}
